// extracted by mini-css-extract-plugin
export default {"main":"TermsScreen_main__YDlyG"};